


/* // src/api/endpoints.js

 */

 const endpoints = {
  // ============================================================
  // ADMIN (SBA Team)
  // ============================================================
  admin: {
    login: '/retailone/auth/retailone/admin/login',
    logout: '/retailone/auth/retailone/admin/logout',
    refresh: '/retailone/auth/retailone/admin/refresh',
    me: '/retailone/auth/retailone/admin/me',
  },

  // ============================================================
  // COMPANY USERS (RetailOne)
  // ============================================================
  retailone: {
    // Auth
    login: '/retailone/auth/retailone/login',
    logout: '/retailone/auth/retailone/logout',
    refresh: '/retailone/auth/retailone/refresh',
    me: '/retailone/auth/retailone/me',
    verifyOTP: '/retailone/auth/retailone/verify-otp',
    resendOTP: '/retailone/auth/retailone/resend-otp',

    // Password Reset
    forgotPassword: '/retailone/auth/retailone/forgot-password',
    resetPassword: '/retailone/auth/retailone/reset-password',
    verifyResetToken: '/retailone/auth/retailone/verify-reset-token',

    // Profile
    profile: '/retailone/api/retailone/users/profile',
    changePassword: '/retailone/api/retailone/users/change-password',
    toggle2FA: '/retailone/api/retailone/users/toggle-2fa',
    companyUsers: '/retailone/api/retailone/users/company-users',

    // ✅ Roles - All endpoints
    roles: '/retailone/api/retailone/roles/',                          // GET (list)
    rolesGet: (uuid) => `/retailone/api/retailone/roles/${uuid}`,     // GET (single)
    rolesCreate: '/retailone/api/retailone/roles/',                   // POST
    rolesUpdate: (uuid) => `/retailone/api/retailone/roles/${uuid}`,  // PUT
    rolesDelete: (uuid) => `/retailone/api/retailone/roles/${uuid}`,  // DELETE
    rolesPermissions: (uuid) => `/retailone/api/retailone/roles/${uuid}/permissions`,  // GET
    rolesAssignPermission: (uuid) => `/retailone/api/retailone/roles/${uuid}/permissions`,  // POST
    rolesRemovePermission: (roleUuid, permissionUuid) => 
      `/retailone/api/retailone/roles/${roleUuid}/permissions/${permissionUuid}`,  // DELETE

    // Invites
    invite: '/retailone/api/retailone/invites/invite',
    invites: '/retailone/api/retailone/invites/list',
    resendInvite: '/retailone/api/retailone/invites/resend',
    acceptInvite: '/retailone/api/retailone/invites/accept',
    verifyInvite: (token) => `/retailone/api/retailone/invites/verify?token=${token}`,
    deleteInvite: (userUuid) => `/retailone/api/retailone/invites/${userUuid}`,

    // Permissions
    permissions: {
      list: '/retailone/api/retailone/permissions/',
      grouped: '/retailone/api/retailone/permissions/grouped',
    },
  },

  sba: {
    verifyInvite: (token) => `/retailone/api/sba/super-admin/verify?token=${token}`,
    acceptInvite: '/retailone/api/sba/invites/super-admin/accept',
  },


   // ============================================================
  // DEV
  // ============================================================

    dev: {
    // Role Permissions by Company
    rolePermissions: (companyId) => `/retailone/dev/role-permissions?company_id=${companyId}`,
    
    // Company Features
    companyFeatures: (companyId) => `/retailone/dev/company-features?company_id=${companyId}`,
    
    // All Companies
    companies: '/retailone/dev/companies',
    
    // Permissions Grouped (Dev)
    permissionsGrouped: '/retailone/dev/permissions/grouped',
  },

  // ============================================================
  // MANAGE USERS
  // ============================================================
  manage_user: {
    list: '/retailone/api/retailone/users/',
    get: (uuid) => `/retailone/api/retailone/users/${uuid}`,
    updateRole: (uuid) => `/retailone/api/retailone/users/${uuid}/role`,
    suspend: (uuid) => `/retailone/api/retailone/users/${uuid}/suspend`,
    reactivate: (uuid) => `/retailone/api/retailone/users/${uuid}/reactivate`,
    delete: (uuid) => `/retailone/api/retailone/users/${uuid}`,
  },

  // ============================================================
  // SUPER ADMIN (Company Management)
  // ============================================================
  superAdmin: {
    companies: '/retailone/api/retailone/admin/companies',
    company: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    createCompany: '/retailone/api/retailone/admin/companies',
    updateCompany: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    deleteCompany: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    stats: '/retailone/api/retailone/admin/stats',
    admins: '/retailone/api/retailone/admin/admins',
    createAdmin: '/retailone/api/retailone/admin/admins',
    updateAdmin: (uuid) => `/retailone/api/retailone/admin/admins/${uuid}`,
    deleteAdmin: (uuid) => `/retailone/api/retailone/admin/admins/${uuid}`,
  },
};

export default endpoints;


 



// src/api/endpoints.js  Generation 2

// src/api/endpoints.js

// src/fapis/endpoints.js

// src/fapis/endpoints.js

/* const endpoints = {
  // ============================================================
  // ADMIN (SBA Team)
  // ============================================================
  admin: {
    login: '/auth/retailone/admin/login',
    logout: '/auth/retailone/admin/logout',
    refresh: '/auth/retailone/admin/refresh',
    me: '/auth/retailone/admin/me',
  },

  // ============================================================
  // COMPANY USERS (RetailOne)
  // ============================================================
  retailone: {
    // Auth
    login: '/auth/retailone/login',
    logout: '/auth/retailone/logout',
    refresh: '/auth/retailone/refresh',
    me: '/auth/retailone/me',
    verifyOTP: '/auth/retailone/verify-otp',
    resendOTP: '/auth/retailone/resend-otp',

    // Password Reset
    forgotPassword: '/auth/retailone/forgot-password',
    resetPassword: '/auth/retailone/reset-password',
    verifyResetToken: '/auth/retailone/verify-reset-token',

    // Profile
    profile: '/api/retailone/users/profile',
    changePassword: '/api/retailone/users/change-password',
    toggle2FA: '/api/retailone/users/toggle-2fa',
    companyUsers: '/api/retailone/users/company-users',

    // ✅ Roles - All endpoints
    roles: '/api/retailone/roles/',                          // GET (list)
    rolesGet: (uuid) => `/api/retailone/roles/${uuid}`,     // GET (single)
    rolesCreate: '/api/retailone/roles/',                   // POST
    rolesUpdate: (uuid) => `/api/retailone/roles/${uuid}`,  // PUT
    rolesDelete: (uuid) => `/api/retailone/roles/${uuid}`,  // DELETE
    rolesPermissions: (uuid) => `/api/retailone/roles/${uuid}/permissions`,  // GET
    rolesAssignPermission: (uuid) => `/api/retailone/roles/${uuid}/permissions`,  // POST
    rolesRemovePermission: (roleUuid, permissionUuid) => 
      `/api/retailone/roles/${roleUuid}/permissions/${permissionUuid}`,  // DELETE

    // Invites
    invite: '/api/retailone/invites/invite',
    invites: '/api/retailone/invites/list',
    resendInvite: '/api/retailone/invites/resend',
    acceptInvite: '/api/retailone/invites/accept',
    verifyInvite: (token) => `/api/retailone/invites/verify?token=${token}`,
    deleteInvite: (userUuid) => `/api/retailone/invites/${userUuid}`,

    // Permissions
    permissions: {
      list: '/api/retailone/permissions/',
      grouped: '/api/retailone/permissions/grouped',
    },
  },

   sba: {
    verifyInvite: (token) => `/api/sba/super-admin/verify?token=${token}`,
    acceptInvite: '/api/sba/invites/super-admin/accept',
  }, 

    sba: {
    verifyInvite: (token) => `/api/sba/super-admin/verify?token=${token}`,
    acceptInvite: '/api/sba/invites/super-admin/accept',
  },


   // ============================================================
  // DEV
  // ============================================================

    dev: {
    // Role Permissions by Company
    rolePermissions: (companyId) => `/dev/role-permissions?company_id=${companyId}`,
    
    // Company Features
    companyFeatures: (companyId) => `/dev/company-features?company_id=${companyId}`,
    
    // All Companies
    companies: '/dev/companies',
    
    // Permissions Grouped (Dev)
    permissionsGrouped: '/dev/permissions/grouped',
  },

  // ============================================================
  // MANAGE USERS
  // ============================================================
  manage_user: {
    list: '/api/retailone/users/',
    get: (uuid) => `/api/retailone/users/${uuid}`,
    updateRole: (uuid) => `/api/retailone/users/${uuid}/role`,
    suspend: (uuid) => `/api/retailone/users/${uuid}/suspend`,
    reactivate: (uuid) => `/api/retailone/users/${uuid}/reactivate`,
    delete: (uuid) => `/api/retailone/users/${uuid}`,
  },

  // ============================================================
  // SUPER ADMIN (Company Management)
  // ============================================================
  superAdmin: {
    companies: '/api/retailone/admin/companies',
    company: (uuid) => `/api/retailone/admin/companies/${uuid}`,
    createCompany: '/api/retailone/admin/companies',
    updateCompany: (uuid) => `/api/retailone/admin/companies/${uuid}`,
    deleteCompany: (uuid) => `/api/retailone/admin/companies/${uuid}`,
    stats: '/api/retailone/admin/stats',
    admins: '/api/retailone/admin/admins',
    createAdmin: '/api/retailone/admin/admins',
    updateAdmin: (uuid) => `/api/retailone/admin/admins/${uuid}`,
    deleteAdmin: (uuid) => `/api/retailone/admin/admins/${uuid}`,
  },
};

export default endpoints; 

 */



// src/api/endpoints.js             generation 1

/* const endpoints = {
  // ============================================================
  // ADMIN (SBA Team)
  // ============================================================
  admin: {
    login: '/retailone/auth/retailone/admin/login',
    logout: '/retailone/auth/retailone/admin/logout',
    refresh: '/retailone/auth/retailone/admin/refresh',
    me: '/retailone/auth/retailone/admin/me',
  },

  // ============================================================
  // COMPANY USERS (RetailOne)
  // ============================================================
  retailone: {
    // Auth
    login: '/retailone/auth/retailone/login',
    logout: '/retailone/auth/retailone/logout',
    refresh: '/retailone/auth/retailone/refresh',
    me: '/retailone/auth/retailone/me',
    verifyOTP: '/retailone/auth/retailone/verify-otp',
    resendOTP: '/retailone/auth/retailone/resend-otp',

    // Password Reset
    forgotPassword: '/retailone/auth/retailone/forgot-password',
    resetPassword: '/retailone/auth/retailone/reset-password',
    verifyResetToken: '/retailone/auth/retailone/verify-reset-token',

    // Profile
    profile: '/retailone/api/retailone/users/profile',
    changePassword: '/retailone/api/retailone/users/change-password',
    toggle2FA: '/retailone/api/retailone/users/toggle-2fa',
    companyUsers: '/retailone/api/retailone/users/company-users',

    // Roles
    roles: '/retailone/api/retailone/roles/',

    // Invites
    invite: '/retailone/api/retailone/invites/invite',
    invites: '/retailone/api/retailone/invites/list',
    resendInvite: '/retailone/api/retailone/invites/resend',
    acceptInvite: '/retailone/api/retailone/invites/accept',
    verifyInvite: (token) => `/retailone/api/retailone/invites/verify?token=${token}`,
    deleteInvite: (userUuid) => `/retailone/api/retailone/invites/${userUuid}`,
  },

  // ============================================================
  // SUPER ADMIN (Company Management)
  // ============================================================
  superAdmin: {
    companies: '/retailone/api/retailone/admin/companies',
    company: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    createCompany: '/retailone/api/retailone/admin/companies',
    updateCompany: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    deleteCompany: (uuid) => `/retailone/api/retailone/admin/companies/${uuid}`,
    stats: '/retailone/api/retailone/admin/stats',
    admins: '/retailone/api/retailone/admin/admins',
    createAdmin: '/retailone/api/retailone/admin/admins',
    updateAdmin: (uuid) => `/retailone/api/retailone/admin/admins/${uuid}`,
    deleteAdmin: (uuid) => `/retailone/api/retailone/admin/admins/${uuid}`,
  },
};

export default endpoints;

 */